export class FormulaChoice {
    recast() {
        return this;
    }
}
